// removed by extract-text-webpack-plugin
module.exports = {"link":"n5_cx","message":"n5_n6","close":"n5_gt"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventTicketsPage/components/CharityModal/styles.module.css
// module id = 1336
// module chunks = 27